<template>
	<main>
	<div class="container">
		<div class="scroll" v-if="!loading">
		<h1 class="page-title">{{pageData.title}}</h1>
		<section class="widget" v-if="pageData.name == 'account'">
			<p class="mb-2">Language settings:</p>
			<select v-model="lang" @change="setLang()">
				<option value="en">English</option>
				<option value="fr">French</option>
			</select>
		</section>
		<section class="widget" v-if="pageData.name == 'account'">
			<button class="btn" @click="logout()">
				<span>Logout</span>
			</button>
		</section>
		<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
		</div>
		<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
	</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
//importing widgets
import textcontent from '../components/widgets/text'
import videowidget from '../components/widgets/video'
import gallerywidget from '../components/widgets/gallery'
import subsectionwidget from '../components/widgets/subsection'
import accordionwidget from '../components/widgets/accordion'

Vue.use(CxltToastr)

export default {
	components: {
	textcontent,
	videowidget,
	gallerywidget,
	accordionwidget,
	subsectionwidget
	},
	props:['type'],
	name: 'settings',
	watch:{ // watching for route name change
	$route (to, from){
		this.$nextTick(() => {
			this.getPagedata()
		})
	}
	},
	computed: { // setting list of widgets
	widgets() {
		return this.components
	}
	},
	data() {
	return {
		ps:null,
		page:'',
		pageData:[],
		components:[],
		comp:[],
		lang: localStorage.lang ? localStorage.lang  : 'en',
		loading:true
	}
	},
	beforeMount: function () {
		this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
		this.axios.get(process.env.VUE_APP_URL+'profiles')
		.catch(error => {
			this.$router.push({name:'login'})
		})
	},
	mounted: function() {
	this.getPagedata()
	},
	methods: {
	getPagedata: function() { // getting current page data
		this.pageData = []
		this.components = []
		this.loading = true
		this.page = this.urlCheck('last')
		let url = this.type == 'subsection' || this.urlCheck('first') ? 'subsection/' : 'section/'
		this.axios.get(process.env.VUE_APP_URL+url+this.page, {params:{name:this.page, language:this.lang}})
		.then(response => {
			this.pageData = response.data
			this.prepareComponents()
		})
		.catch(error => {
			this.$router.push({name:'login'})
		})
	},
	prepareComponents: function(){ // making widgets array
		if(this.pageData.accordions && this.pageData.accordions.length > 0) {
			this.pageData.accordions.map(a => {
			a.type = 'accordionwidget'
			this.components.push(a)
			})
		}
		if(this.pageData.galleries && this.pageData.galleries.length > 0) {
			this.pageData.galleries.map(a => {
			a.type = 'gallerywidget'
			this.components.push(a)
			})
		}
		if(this.pageData.subsections && this.pageData.subsections.length > 0) {
			this.pageData.subsections.map(a => {
			a.type = 'subsectionwidget'
			this.components.push(a)
			})
		}
		if(this.pageData.videos && this.pageData.videos.length > 0) {
			this.pageData.videos.map(a => {
			a.type = 'videowidget'
			this.components.push(a)
			})
		}
		if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
			this.pageData.text_contents.map(a => {
			a.type = 'textcontent'
			this.components.push(a)
			})
		}
		this.$nextTick(() => {
			this.sortComponents()
		})
	},
	sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
			if (a.index < b.index)
					return -1;
			if (a.index > b.index)
					return 1;
			return 0;
			}
			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
				this.perfectScrollInit()
			})
	},
	urlCheck: function(type) { // checking path for 3 level menu and getting menu name
			let url = this.$route.path.split('/')
			return type == 'last' ? url[url.length-1] : url.length > 3 ? true : false
	},
	setLang: function() { // setting global lang
		localStorage.lang = this.lang
		location.reload()
	},
	logout: function() { // loggin out user
		localStorage.token = ''
		this.axios.post(process.env.VUE_APP_URL+'logout')
		.then(response=>{
			this.$toast.success({
				title:'Success',
				message: 'You have been logged out successfully',
				position: 'top right',
				timeOut: 5000
			})
			this.$router.push({path: '/page/prevent'})
		})
	},
	perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
			this.ps = new PerfectScrollbar(container)
			} else if(container) {
			this.ps.destroy()
			this.ps = null
			this.ps = new PerfectScrollbar(container)
			container.scrollTop = 0
			}
	}
	}
}

</script>